import { FilterGroup } from 'components/Filters/components/FilterModal'

import { FilterIdentifier } from 'models/saved_view'
import { filterStoreRepo } from '../../Filters/FilterStore'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { SELECT_LOCATIONS } from './selectLocationsForDealColumnInfo'
import { CityAndStateFilter } from 'components/Filters/components/CityAndStateFilter'
import { ZipcodeFilter } from 'components/Filters/fields/ZipcodeFilter'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { DMA_OPTIONS } from 'models/dma_options'
import SelectSavedFilter from 'components/Filters/saved-filters/SelectSavedFilter'
import { MobileFilterCriteriaSelect } from 'components/MobileFilterCriteriaSelect'
import { FilterChips } from 'components/Filters/components/FilterChips/FilterChips'

export function MobileLocationsFilterset(props: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const selectLocationsForDealFilterStore = filterStoreRepo.getStore(
    props.filterIdentifier
  )

  const selectLocationsForDealFilterHelper = createFilterColumnHelper({
    columns: SELECT_LOCATIONS,
  })

  return (
    <>
      <div className="mb-2">
        <SelectSavedFilter
          filterStore={selectLocationsForDealFilterStore}
          identifier={props.filterIdentifier}
        />
      </div>
      <FilterGroup
        className="flex flex-col gap-2"
        title={'Opportunity Details'}
      >
        <CityAndStateFilter
          filterStore={selectLocationsForDealFilterStore}
          citySelectProps={selectLocationsForDealFilterHelper.retrieveProps(
            'city'
          )}
          stateSelectProps={selectLocationsForDealFilterHelper.retrieveProps(
            'state'
          )}
        />
        <ZipcodeFilter filterStore={selectLocationsForDealFilterStore} />
        <SelectFilter
          filterStore={selectLocationsForDealFilterStore}
          {...selectLocationsForDealFilterHelper.retrieveProps('dma')}
          options={DMA_OPTIONS}
        />
      </FilterGroup>
      <MobileFilterCriteriaSelect
        filterStore={selectLocationsForDealFilterStore}
      />
      <FilterChips
        identifier={props.filterIdentifier}
        store={selectLocationsForDealFilterStore}
        className="ml-0"
        clearAllButton
      />
    </>
  )
}
